import { useEffect, useRef } from 'react';
import { useLocation } from '@tanstack/react-router';
import { StoredInviteCode } from '@/shared/utils/Stored';
import { emitInviteCode } from '@/modules/invite-code-signal';

export default function useInviteCode() {
  const location = useLocation();
  const ranRef = useRef(false);

  useEffect(() => {
    if (ranRef.current) return;
    ranRef.current = true;
    const params = new URLSearchParams(location.searchStr);
    const code = params.get('invite_code');
    if (code == null || code === '') return;
    StoredInviteCode.set(code);
    params.delete('invite_code');
    const newSearch = params.toString();
    const newUrl =
      window.location.pathname + (newSearch !== '' ? `?${newSearch}` : '');
    window.history.replaceState(null, '', newUrl);
    emitInviteCode(code);
  }, [location.searchStr]);
}
